// extracted by mini-css-extract-plugin
export default {"regular":"F80ILKIrTk4mymjNpqpf","xs":"gvbCMe_lQkd6bRBLjhYm"};